<template>
  <b-modal
    size="md"
    hide-footer
    v-model="show"
    title="Edição da Configuração do Sistema"
    @hidden="cancelar"
  >
    <b-card>
      <b-row>
        <b-col cols="12">
          <div><span class="font-weight-bold">Configuração:</span> {{ configuracao.tituloPropriedade }}</div>
        </b-col>
      </b-row>
    </b-card>
    <b-form @submit.prevent="salvar">
      <b-form-group>
        <lg-form-input
          v-model="form.valor"
          label="Valor:"
          required
          type="number"
          :step="stepValue"
        />
      </b-form-group>
      <b-form-row class="d-flex justify-content-center">
        <b-button type="submit" size="sm" pill variant="success">
          <b-icon icon="check-circle" />
        </b-button>
        <b-button size="sm" pill variant="danger" @click="cancelar" class="ml-2">
          <b-icon icon="x-circle" />
        </b-button>
      </b-form-row>
    </b-form>
  </b-modal>
</template>

<script>
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import Swal from "sweetalert2";
import lgFormInput from "@/core/components/Form/LgFormInput.vue";

export default {
  components: {
    lgFormInput,
  },
  props: {
    configuracao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      form: {
        valor: "",
      },
      stepValue: 1,
    };
  },
  methods: {
    async salvar() {
      if (this.form.valor === "") {
        this.$bvToast.toast("Preencha o valor", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
        return;
      }

      const payload = {
        id: this.configuracao.id,
        valorPropriedade: this.form.valor.toString(),
      };

      try {
        await ConfiguracaoSistemaService.atualizarConfiguracao(payload);
        this.$emit("salvo");
        await Swal.fire({
          title: "Sucesso",
          text: "Configuração salva com sucesso!",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        this.$bvToast.toast("Erro ao salvar configuração", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
      }
    },
    cancelar() {
      this.$emit("close");
    },
    carregarDadosIniciais() {
      this.form.valor = this.configuracao.valorPropriedade || "";
    },
  },
  mounted() {
    this.carregarDadosIniciais();
  },
};
</script>

<style scoped>
.font-weight-bold {
  font-weight: bold;
}
</style>
